import { lazy } from 'react';

const PliCoverRoute = lazy(
  () => import(/* webpackChunkName: "PliCover" */ '../components/steps/pli-cover-step/PliCover'),
);

export default PliCoverRoute;
